import { AccordionItem } from "./profile-form";

import AlternateEmailOutlinedIcon from "@mui/icons-material/AlternateEmailOutlined";
import PhoneIcon from "@mui/icons-material/Phone";

// Design `.main`: 96px sidebar offset, left-aligned, max-width 980, 36px padding
const mainWrap =
  "max-w-[980px] min-[880px]:ml-24 px-[12px] pt-[18px] pb-24 min-[880px]:px-9 min-[880px]:pt-7 min-[880px]:pb-[60px]";

const ContactRow = ({ icon, href, main, sub, divider }) => (
  <div
    className={[
      "flex items-start gap-[14px] py-[8px]",
      divider
        ? "border-t-[1px] border-solid border-[rgba(255,122,122,0.45)] pt-[16px] mt-[8px]"
        : "",
    ].join(" ")}
  >
    <span className="text-[#ea4d3d] w-[28px] shrink-0 flex justify-center pt-[2px]">
      {icon}
    </span>
    <a href={href} className="no-underline block min-w-0 flex-1">
      <div className="text-[16px] font-bold text-white font-body-primary">{main}</div>
      {sub && (
        <div className="text-[13px] text-[#8a8a96] mt-[2px] font-normal font-body-primary">
          {sub}
        </div>
      )}
    </a>
  </div>
);

const HelpSupport = () => {
  return (
    <div className="overflow-x-auto text-white">
      <div className={mainWrap}>
        {/* Topbar */}
        <div className="flex items-center gap-[12px] mt-[4px] mb-[22px] mx-[4px]">
          <h1 className="m-0 text-[26px] font-bold font-headings-primary tracking-[-0.01em] text-white">
            Help
          </h1>
        </div>

        <div className="flex flex-col gap-[14px]">
          {/* Contact card */}
          <div className="bg-[#14141d] border-[1px] border-solid border-[#20202c] rounded-2xl px-[22px] py-[18px]">
            <ContactRow
              icon={<AlternateEmailOutlinedIcon style={{ fontSize: 22 }} />}
              href="mailto:vendors@bestgiftgroup.com"
              main="vendors@bestgiftgroup.com"
            />
            <ContactRow
              divider
              icon={<PhoneIcon style={{ fontSize: 20 }} />}
              href="tel:+61292116088"
              main="+61 2 9211 6088"
              sub="9-5pm business days (Sydney time)"
            />
          </div>

          {/* FAQ */}
          <AccordionItem title="Scan button missing?">
            <p className="m-0 mb-[10px]">
              The portal needs camera access to scan cards, saving manual entry. If you
              don’t see the Scan button, your browser may have blocked it.
            </p>
            <ol className="m-0 mb-[10px] pl-[20px] list-decimal">
              <li className="my-[2px]">Open your browser settings.</li>
              <li className="my-[2px]">Search “Camera”.</li>
              <li className="my-[2px]">Remove any block for the vendor portal site.</li>
            </ol>
            <p className="m-0">
              Next time you log in, allow camera access when prompted and the Scan button
              will reappear.
            </p>
          </AccordionItem>

          <AccordionItem title="How do I change my password?">
            <p className="m-0">
              On the <strong className="text-white font-bold">login page</strong>, click{" "}
              <strong className="text-white font-bold">Reset password</strong> and follow
              the prompts. Then, log in and save it securely (your browser can remember it).
            </p>
          </AccordionItem>

          <AccordionItem title="I can’t redeem a gift card, what do I do?">
            <p className="m-0">
              If a gift card fails for any reason, charge the customer via other means and
              ask them to contact{" "}
              <a
                href="mailto:cardholder@bestgiftgroup.com"
                className="text-[#ea4d3d] no-underline"
              >
                cardholder@bestgiftgroup.com
              </a>
              . We'll process the redemption, refund the customer, and issue a credit note
              to you if applicable so you're not out of pocket.
            </p>
          </AccordionItem>

          <AccordionItem title="When will I be paid?">
            <p className="m-0">
              Redemptions are processed daily, with payments made to your nominated account
              on a monthly cycle. For payment queries, email:{" "}
              <a
                href="mailto:vendors@bestgiftgroup.com"
                className="text-[#ea4d3d] no-underline"
              >
                vendors@bestgiftgroup.com
              </a>
              .
            </p>
          </AccordionItem>
        </div>

        {/* Legals */}
        <div className="flex items-center gap-[14px] mt-7 pt-2 px-1.5 text-[13px] text-[#8a8a96] font-body-primary">
          <a
            href="https://bestgiftgroup.com/terms-conditions-vendors/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#8a8a96] no-underline hover:text-white hover:underline transition-colors"
          >
            Terms &amp; Conditions
          </a>
          <span className="text-[#8a8a96] opacity-60">|</span>
          <a
            href="https://bestgiftgroup.com/privacy-policy/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#8a8a96] no-underline hover:text-white hover:underline transition-colors"
          >
            Privacy Policy
          </a>
        </div>
      </div>
    </div>
  );
};
export { HelpSupport };
